import React, { createContext, useContext, useState } from 'react';

export interface CarrierDownloadStats {
  total: number;
  byStatus: Record<string, number>;
  byProvider: Record<string, number>;
  byType: Record<string, number>;
}

interface CarrierDownloadStatsContextValue {
  stats: CarrierDownloadStats;
  setStats: (stats: CarrierDownloadStats) => void;
}

const EMPTY_STATS: CarrierDownloadStats = { total: 0, byStatus: {}, byProvider: {}, byType: {} };

const CarrierDownloadStatsContext = createContext<CarrierDownloadStatsContextValue>({
  stats: EMPTY_STATS,
  setStats: () => {},
});

export const CarrierDownloadStatsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [stats, setStats] = useState<CarrierDownloadStats>(EMPTY_STATS);
  return (
    <CarrierDownloadStatsContext.Provider value={{ stats, setStats }}>
      {children}
    </CarrierDownloadStatsContext.Provider>
  );
};

export const useCarrierDownloadStats = () => useContext(CarrierDownloadStatsContext);
